import React from 'react';

/**
 * Card component for bento/rounded UI.
 * Used as the main content area for the simulator.
 */
const Card = React.forwardRef(({ children, className = '' }, ref) => {
  return (
    <div
      ref={ref}
      className={`bg-white rounded-2xl shadow-soft p-4 sm:p-8 w-full max-w-md sm:max-w-lg ${className}`}
      role="region"
      aria-label="Simulator Content"
    >
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card; 